import { axiosInstance } from "@/use/utilities/axios/app/axios-instance";

export async function checkPendingRequest(testWorkQueueId) {
  const axios = axiosInstance().primoLab;
  
  try {
    const { data } = await axios.get('/clinic-deliveries/check-pending-request', {
      params: {
        test_work_queue_id: testWorkQueueId
      }
    });
    return data.data;
  } catch (error) {

    if (error.response?.status === 404) {
      return { has_pending_request: false };
    }
    const errorMessages = error.response?.data?.errors || error.response?.data?.message || ['Errore nel controllo della richiesta'];
    throw new Error(Array.isArray(errorMessages) ? errorMessages.join(', ') : errorMessages);
  }
}

